import React, { Component } from "react";
import { Thumbnail } from "@culturehq/components";

import ErrorBoundary from "components/common/ErrorBoundary";
import CommentForm from "components/comments/CommentForm";

class CommentsForm extends Component {
  static defaultProps = {
    onChange: () => {}
  };

  constructor(props) {
    super(props);

    this.state = { success: false };
  }

  componentDidMount() {
    this.componentIsMounted = true;
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  handleSubmit = async values => {
    const { options, createCall, onCreateComment } = this.props;

    this.setState({ success: false });

    const { comment } = await createCall({ ...options, ...values });
    onCreateComment(comment);

    if (!comment.parentCommentId) {
      setTimeout(() => this.setState({ success: false }), 2000);
    }
  };

  render() {
    const { profile, showAvatar } = this.props;
    const { success } = this.state;

    return (
      <div className="comments row clearfix">
        <div className="col-sm-12">
          <ErrorBoundary>
            {showAvatar && (
              <div className="comments--avatar">
                <Thumbnail image={profile.avatar.thumbUrl} />
              </div>
            )}
            <CommentForm onSubmit={this.handleSubmit} success={success} />
          </ErrorBoundary>
        </div>
      </div>
    );
  }
}

export default CommentsForm;
